import sweetAlert from 'sweetalert2/dist/sweetalert2.css?inline';
import common from './common.scss?inline';
import modal from './pop-up-modal.scss?inline';
import slideIn from './slide-in-box.scss?inline';
import banner from './banner.scss?inline';
import inline from './inline.scss?inline';
import preview from './preview-modals.scss?inline';

// Beacon embeds load only JavaScript. Preserve stylesheet order and insertion
// before engagement UI is constructed without requiring a customer CSS tag.
for (const css of [sweetAlert, common, modal, slideIn, banner, inline, preview]) {
   const style = document.createElement('style');
   style.textContent = css;
   document.head.appendChild(style);
}
